import React from 'react';
import { useChannel } from '@services/channels';
import ChannelHeader from '../ChannelHeader';
import DeliveryMenuSettings from '../DeliveryMenuSettings';
import DeliveryStoreSettings from '../DeliveryStoreSettings';
import { useShop } from '@services/ShopProvider';

const DeliverySettings = ({ channelId, hasOpeningHours = false, fields = [] }) => {
	const { shop } = useShop();
	const { data: channel, mutate: mutateChannel } = useChannel(channelId, shop.id);
	return (
		<>
			<ChannelHeader channelId={channelId} status={channel?.status} actions />
			<DeliveryStoreSettings channel={channel} hasOpeningHours={hasOpeningHours} fields={fields} />
			<DeliveryMenuSettings channel={channel} mutateChannel={mutateChannel} />
		</>
	);
};

export default DeliverySettings;
